import { defineComponent } from 'vue';
import { createPopper, flip, hide } from '@popperjs/core';
import { delayFrames } from '../utility';

export default defineComponent({
    data() {
        return {
            openMenuId: null,

            popperInstanceRow: null,
            openMenuAtEnd: false,

            popperDestroyTimerHandle: null,

            contextMenuX: 0,
            contextMenuY: 0,
            contextMenuShown: false,
        }
    },
    computed: {
        virtualMouseElement() {
            return {
                getBoundingClientRect: this.getVirtualBoundingBox
            }
        },
    },
    methods: {
        clickListenerMenu() {
            //this.$emit('update:openMenuId', null)
            this.openMenuId = null
            this.contextMenuShown = false
        },
        getVirtualBoundingBox() {
            return {
                width: 0,
                height: 0,
                top: this.contextMenuY,
                right: this.contextMenuX,
                bottom: this.contextMenuY,
                left: this.contextMenuX
            }
        },
        async onRowContextMenu(e) {
            // TODO - Finish this
            //console.log('onRowContextMenu', e)
            e.originalEvent.preventDefault()
            this.contextMenuShown = false
            this.contextMenuX = e.originalEvent.clientX
            this.contextMenuY = e.originalEvent.clientY
            await this.$nextTick()
            this.contextMenuShown = true
            this.openMenuId = e.data.id
        }
    },
    watch: {
        async openMenuId(val) {

            document.removeEventListener('click', this.clickListenerMenu)
            clearTimeout(this.popperDestroyTimerHandle)

            if (val == null) {
                //await delay(500)

                this.popperDestroyTimerHandle = setTimeout(() => {
                    this.popperInstanceRow?.destroy()
                }, 300)

                return
            }

            // Must wait one tick, to await portal contents init.
            await this.$nextTick()

            const btnSetReference = document.querySelector(`#btnSet${val}`)
            const trReference = btnSetReference.parentElement.parentElement
            const trBoundingClientRectFunction = trReference.getBoundingClientRect
            const trBoundingClientRect = trReference.getBoundingClientRect()
            //console.log('trBoundingClientRect', trBoundingClientRect)
            let reference


            function newBoundingClientRectFunction() {

                const currentBoundingClientRect = trBoundingClientRectFunction.bind(this)()

                return new DOMRect(
                    currentBoundingClientRect.x,
                    currentBoundingClientRect.y,
                    currentBoundingClientRect.width,
                    0
                )
            }

            trReference.getBoundingClientRect = newBoundingClientRectFunction.bind(trReference)

            //console.log(trReference.getBoundingClientRect())
            if (this.contextMenuShown) {
                reference = trReference/*{
                    getBoundingClientRect: trReference.getBoundingClientRect,
                }*/
            } else {
                reference = btnSetReference
            }

            //console.log('reference', reference)

            //const rowDropMenu = this.$refs[`rowDropMenu${val}`].$el
            const rowDropMenu = document.querySelector(`#rowDropMenu${val}`)

            //console.log('rowDropMenu.offsetWidth', rowDropMenu.querySelector('.v-menu__content').offsetWidth)

            if (this.popperInstanceRow) this.popperInstanceRow.destroy()

            //minWidth.options = { test: true }
            //minWidth.data = { test2: true }
            //console.log('minWidth', minWidth)

            const modifiers = [
                //sameWidth,
                //preventOverflow,
                flip,
                //minWidth,
                hide
            ]

            if (this.contextMenuShown) {
                modifiers.push({
                    name: 'offset',
                    options: {
                        offset: [
                            trBoundingClientRect.x + this.contextMenuX + 8,
                            this.contextMenuY - trBoundingClientRect.y - trBoundingClientRect.height + 8
                        ]
                    }
                })
            }

            //if (this.contextMenuShown) modifiers.push(minWidth)

            this.popperInstanceRow = createPopper(reference, rowDropMenu, {
                placement: this.openMenuAtEnd ? 'bottom-end' : 'bottom-start',
                modifiers

            })

            // Await two frames to update the popper position after creation.
            // Menu takes two frames to init. Popper auto updates its position when
            // we scroll, that's taken care of.
            // Without this update, the popper menu will not 'flip' side when
            // opened so that it overflows the document downwards. It will be
            // laid out so that it goes out of viewport bounds, which we don't want.
            await delayFrames(2)

            if (this.popperInstanceRow) {
                this.popperInstanceRow.update()
            }

            document.addEventListener('click', this.clickListenerMenu)

        },

        /*contextMenuShown(val) {
            console.log('contextMenuShown', val)
        }*/
    }
});
